module.exports = __webpack_public_path__ + "static/media/bytt-no-15.8fd7c2b5.mp3";